import { render } from "./Confeti.vue?vue&type=template&id=06a985b4"
const script = {}

import "./Confeti.vue?vue&type=style&index=0&id=06a985b4&lang=css"

import exportComponent from "C:\\Users\\Nacho\\Programación\\Vue\\tombolacredix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__